<div>
  <input type="file" (change)="selectFile($event)" />
</div>
<button class="upload-file" *ngIf="isFileSelected" (click)="upload()">
  Upload
</button>
